import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { addNotificationToQueue, removeNotificationFromQueue, removeQueues } from './actionCreators';
import { reduxKey } from './constants';
const MAX_NOTIFICATION_AGE = 60000;
function isValidNotification(item) {
    // do not expire notifications during tests
    if (process.env.NODE_ENV === 'test') {
        return true;
    }
    return Date.now() - item.created < MAX_NOTIFICATION_AGE;
}
const handler = handleActions({
    [addNotificationToQueue.toString()]: (state, { payload: { notification, queueName } })=>{
        const queue = (state[queueName] || []).filter(isValidNotification);
        return _object_spread_props(_object_spread({}, state), {
            [queueName]: [
                ...queue,
                notification
            ]
        });
    },
    [removeNotificationFromQueue.toString()]: (state, { payload: { queueName, id } })=>{
        if (!state[queueName]) {
            return state;
        }
        const queue = state[queueName].filter(isValidNotification);
        return _object_spread_props(_object_spread({}, state), {
            [queueName]: queue.filter((item)=>item.id !== id)
        });
    },
    [removeQueues.toString()]: (state, { payload: { predicate } })=>{
        const queues = Object.keys(state).filter((queueName)=>queueName === 'default' ? true : !predicate(queueName));
        // Inferred typing on pick here is a bit bad
        return pick(state, queues);
    }
}, {
    default: []
});
export default {
    [reduxKey]: handler
};

//# sourceMappingURL=reducer.js.map